export function applyTheme(theme) {
  if (!theme) return;
  const r = document.documentElement;
  const map = {
    "--bg": theme.bg,
    "--surface": theme.surface,
    "--surface-alt": theme.surfaceAlt,
    "--primary": theme.primary,
    "--primary-fg": theme.primaryFg,
    "--secondary": theme.secondary,
    "--secondary-fg": theme.secondaryFg,
    "--accent": theme.accent,
    "--accent-fg": theme.accentFg,
    "--text": theme.text,
    "--text-muted": theme.textMuted,
    "--border": theme.border,
    "--ring": theme.ring,
    "--radius": theme.radius,
    "--heading-font": theme.headingFont ? `"${theme.headingFont}", serif` : undefined,
    "--body-font": theme.bodyFont ? `"${theme.bodyFont}", sans-serif` : undefined,
  };
  Object.entries(map).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") r.style.setProperty(k, v);
  });
}
